module.exports = __webpack_public_path__ + "img/like.0de73be9.svg";